/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ControlExtendedDto } from './ControlExtendedDto';
import {
    ControlExtendedDtoFromJSON,
    ControlExtendedDtoFromJSONTyped,
    ControlExtendedDtoToJSON,
    ControlExtendedDtoToJSONTyped,
} from './ControlExtendedDto';

/**
 * 
 * @export
 * @interface ControlResponse
 */
export interface ControlResponse {
    /**
     * 
     * @type {ControlExtendedDto}
     * @memberof ControlResponse
     */
    data?: ControlExtendedDto;
}

/**
 * Check if a given object implements the ControlResponse interface.
 */
export function instanceOfControlResponse(value: object): value is ControlResponse {
    return true;
}

export function ControlResponseFromJSON(json: any): ControlResponse {
    return ControlResponseFromJSONTyped(json, false);
}

export function ControlResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ControlExtendedDtoFromJSON(json['data']),
    };
}

export function ControlResponseToJSON(json: any): ControlResponse {
    return ControlResponseToJSONTyped(json, false);
}

export function ControlResponseToJSONTyped(value?: ControlResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ControlExtendedDtoToJSON(value['data']),
    };
}

